document.addEventListener('DOMContentLoaded', function () {
	const querySliders = document.querySelectorAll('.salsnes-query-slider');

	querySliders.forEach(function (slider) {
		const buttons = slider.querySelectorAll('.salsnes-query-slider__button');
		const items = slider.querySelectorAll('.salsnes-query-slider__item');

		// Initialize slider
		let currentIndex = 0;

		// Show specific post by index
		function showPostByIndex(postIndex) {
			// Hide all items first
			items.forEach((item, index) => {
				item.style.display = 'none';
				item.classList.remove('active');
			});

			// Show the specific post with animation
			if (items[postIndex]) {
				items[postIndex].style.display = 'block';
				// Small delay to allow CSS transition to work
				setTimeout(() => {
					items[postIndex].classList.add('active');
				}, 10);
				currentIndex = postIndex;
			}
		}

		// Button click handlers
		buttons.forEach((button, index) => {
			button.addEventListener('click', function () {
				// Update active button
				buttons.forEach((btn) => btn.classList.remove('active'));
				this.classList.add('active');

				// Get post index
				const postIndex = this.getAttribute('data-post-index');

				if (postIndex !== null) {
					// Show specific post by index
					showPostByIndex(parseInt(postIndex));
				}
			});
		});

		// Initialize with first item active
		if (items.length > 0) {
			showPostByIndex(0);
		}
	});
});
